import { Link } from '@ecm/router';

import { AbstractContractItemViewModel } from '../abstract-contract.view-model';

export class ProtectedHouseContractViewModel extends AbstractContractItemViewModel {
    public picto: string;
    public messages?: string[];
    public button?: string;
    public linkInternet?: Link;
    public activeContract = true;
}
